import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FaBriefcase, FaArrowRight } from 'react-icons/fa';

const HomeCareers = () => {
    const { t } = useTranslation();

    return (
        <section className="py-20 bg-white relative overflow-hidden">
            {/* Background Decoration */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-primary/5 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-secondary/5 rounded-full translate-y-1/2 -translate-x-1/2 blur-3xl"></div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="bg-primary-dark rounded-[3rem] p-8 md:p-16 shadow-2xl overflow-hidden relative border border-white/10">
                    {/* Pattern Overlay */}
                    <div className="absolute inset-0 opacity-5 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:20px_20px]"></div>

                    <div className="flex flex-col lg:flex-row items-center justify-between gap-12 relative z-10">
                        <div className="lg:max-w-2xl text-center lg:text-left">
                            <div className="inline-flex items-center gap-3 bg-white/10 px-4 py-2 rounded-full text-secondary font-bold text-sm uppercase tracking-widest mb-6 border border-white/5">
                                <FaBriefcase className="animate-bounce" /> {t('careers.subtitle')}
                            </div>
                            <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6 leading-tight">
                                {t('careers.title')}
                            </h2>
                            <p className="text-blue-100 text-lg md:text-xl leading-relaxed mb-10 opacity-90">
                                {t('careers.description')}
                            </p>
                            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                                <Link
                                    to="/careers"
                                    className="bg-secondary hover:bg-secondary-dark text-white px-10 py-5 rounded-2xl font-bold transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center justify-center gap-3 text-lg"
                                >
                                    {t('careers.applyNow')} <FaArrowRight />
                                </Link>
                                <Link
                                    to="/about"
                                    className="bg-white/10 hover:bg-white/20 text-white px-10 py-5 rounded-2xl font-bold transition-all border border-white/20 flex items-center justify-center gap-3 text-lg backdrop-blur-sm"
                                >
                                    {t('careers.learnMore')}
                                </Link>
                            </div>
                        </div>

                        <div className="hidden lg:block relative">
                            <div className="w-80 h-80 bg-white/5 rounded-full flex items-center justify-center p-8 border border-white/10 backdrop-blur-md">
                                <div className="w-full h-full bg-white/10 rounded-full flex items-center justify-center border border-white/10">
                                    <FaBriefcase className="text-8xl text-secondary opacity-80" />
                                </div>
                            </div>
                            {/* Decorative elements */}
                            <div className="absolute -top-4 -right-4 w-12 h-12 bg-secondary rounded-full border-4 border-primary-dark shadow-xl"></div>
                            <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-primary rounded-full border-4 border-primary-dark shadow-xl opacity-50"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeCareers;
